import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import JobTrainingSkillsDetails from '../../subdepartmentdetails/JobTrainingSkills'


function JobTrainingSkills() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Job Training and Skills Development || Employment and Workforce Development";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Employment Workforce"
            title="Job Training Skills"
            subtitledown="Department of Employment & Workforce Development"
           />
            <JobTrainingSkillsDetails/>
        </div>
    </>
  )
}

export default JobTrainingSkills